import { connect } from 'react-redux';
import {
    setStep,
    updateOrder,
    updateValids,
    setAttempted,
    setShippingLocations,
    setConcessionInfo,
    setStartForm
} from 'Actions/form';
import { clearShippingInfo } from 'Actions/shipping';
import Form from './Form';

const mapStateToProps = (state) => ({
    step: state.form.step,
    order: state.form.order,
    shirtDetails: state.shirt,
    paymentDetails: state.payment,
    shippingDetails: state.shipping,
    nextAttempted: state.form.nextAttempted,
    valids: state.form.valids,
    shippingLocations: state.form.shippingLocations,
    concessionInfo: state.form.concessionInfo,
    startForm: state.form.startForm
});

const mapDispatchToProps = (dispatch) => ({
    setStep: (step) => dispatch(setStep(step)),
    updateOrder: (new_order) => dispatch(updateOrder(new_order)),
    setAttempted: (toggle) => dispatch(setAttempted(toggle)),
    updateValids: (new_valids) => dispatch(updateValids(new_valids)),
    setShippingLocations: (shipping_locations) => dispatch(setShippingLocations(shipping_locations)),
    clearShippingInfo: () => dispatch(clearShippingInfo()),
    setConcessionInfo: (concession_info) => dispatch(setConcessionInfo(concession_info)),
    setStartForm: () => dispatch(setStartForm(true))
});

export default connect(mapStateToProps, mapDispatchToProps)(Form);
